// Most queries are in `@/graphql/queries` which is auto-generated
// This file is for queries beyond that

export default {};

export const SearchJobs = `
  query SearchJobs(
    $filter: SearchableJobFilterInput
    $sort: SearchableJobSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchJobs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobNr
        startDate
        clientRef
        product
        product2
        name
        townSuburb
        status
        priority
        jobClientId
        notes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
        }
        supplierTitle
      }
      nextToken
      total
    }
  }
`;

export const ExportJobs = `
  query ExportJobs(
    $filter: SearchableJobFilterInput
    $sort: SearchableJobSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchJobs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        jobNr
        parts {
          items {
            id
            dateOrdered
            quantity
            partOrdered
          }
          nextToken
        }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        supplierTitle
      }
      nextToken
      total
    }
  }
`;
